@if (metaData) {
    <span class="pod-metadata-title"> {{ metaData }} </span>
}
@if (event) {
    <ms-event-info class="event-timer" [event]="event" [disableBadges]="disableBadges"></ms-event-info>
}
@if (pod.isPromotionTag) {
    <ng-container *msShowInEpcot="false">
        <ms-promotion-badge></ms-promotion-badge>
    </ng-container>
}
